export default __webpack_public_path__ + "img/d41021cb7bd1334d72a8fd1902c7327a.jpg";